export default __webpack_public_path__ + "static/media/view.5379ea45.webp";